(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dummy-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const scrollTriggers = document.querySelectorAll('.js-dummy-rating-scroll-trigger');
    const dummyReviewsSection = document.querySelector('.js-dummy-reviews');

    if (dummyReviewsSection && scrollTriggers) {
      scrollTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const headerOffset = document.querySelector('.header-sticky')?.offsetHeight;
          const elementPosition = dummyReviewsSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
